export default "__VITE_ASSET__DS2yZhR0__"